import { Box, BoxProps, Typography } from "@mui/material"
import Logo from "./images/logo_img01.png"
import { Link } from "react-router-dom"

export const Header = (props: BoxProps) => {
  const fontFamily = [
    "メイリオ",
    "Meiryo",
    "ヒラギノ角ゴ Pro W3",
    "Hiragino Kaku Gothic Pro",
    "Osaka",
    "ＭＳ Ｐゴシック",
    "MS PGothic",
    "sans-serif"
  ]
  return (
    <Box {...props} sx={{ borderBottom: 1, borderColor: "grey.400", marginBottom: "2em" }}>
      <Box display={"flex"}>
        <Link to={"http://miraiz-connect.co.jp/"} target="_blank">
          <Box
            component="img"
            sx={{ height: 64 }}
            alt="Logo"
            src={Logo}
          /></Link>
        <Box display={"grid"} justifyContent={"center"} alignContent={"center"} sx={{ height: 64 }}>
          <Typography fontWeight={"bold"} fontSize={15} fontFamily={fontFamily} color="primary">
            UR都市機構入居者様専用 お問い合わせフォーム
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
export const TerashiteHeader: React.FC = () => {
  return (
    <div id="headerBlockBg">
      <div id="headerBlock">
        <header>
          <h1 className="siteLogo">
            <img src="/019e719d-361f-7331-bbf1-d4956cbc484b/common/img/siteLogo.svg" alt="テラシテR" />
          </h1>
        </header>
      </div>
    </div>
  )
}
